import { render } from "./RoadMapInitiatives.vue?vue&type=template&id=25f0f192"
import script from "./RoadMapInitiatives.vue?vue&type=script&lang=js"
export * from "./RoadMapInitiatives.vue?vue&type=script&lang=js"

import "./RoadMapInitiatives.vue?vue&type=style&index=0&id=25f0f192&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__